import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const LOGO_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_71357793-066d-495c-9261-d3cf17458b15/artifacts/uaudh6f5_ONceWay%20Logo.png";

export const WHATSAPP_NUMBER = "918660338714"; // +91 86603 38714
export const WHATSAPP_LINK = (msg = "Hi Once Way, I'd love to know more about your trips!") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const CONTACT_EMAIL = "info@oncewaytravel.com";
export const INSTAGRAM = "https://instagram.com/oncewaytravel";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Group Trips", to: "/trips" },
  { label: "Private Trips", to: "/private-trips" },
  { label: "About", to: "/about" },
  { label: "Journal", to: "/blog" },
  { label: "Contact", to: "/contact" },
];
